import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';

export const Header = ({ onBookNow }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'Attractions', path: '/attractions' },
    { name: 'Parties & Events', path: '/events' },
    { name: 'Gallery', path: '/gallery' },
    { name: 'About', path: '/about' },
    { name: 'Contact', path: '/contact' },
    { name: 'FAQ', path: '/faq' }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-page border-b-2 border-green backdrop-blur-md bg-opacity-95">
      <div className="container mx-auto px-6 py-3">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2 group">
            <img 
              src="/logo.jpeg" 
              alt="The Br8k Room" 
              className="h-12 w-auto"
              style={{ filter: 'drop-shadow(0 0 10px rgba(0, 255, 65, 0.3))' }}
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-4 py-2 text-sm font-semibold transition-all rounded-full uppercase tracking-wider ${
                  isActive(link.path)
                    ? 'text-inverse bg-gradient-to-r from-primary to-blue border-2 border-primary'
                    : 'text-primary hover:text-blue border-2 border-transparent hover:border-blue'
                }`}
                style={isActive(link.path) ? { boxShadow: '0 0 15px rgba(0, 255, 65, 0.5)' } : {}}
              >
                {link.name}
              </Link>
            ))}
          </nav>

          {/* Book Now Button */}
          <div className="hidden lg:block">
            <Button onClick={onBookNow} className="btn-primary font-bold">
              Book Now
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="lg:hidden p-2 text-primary hover:text-pink transition-colors"
            aria-label="Toggle menu"
            style={{ filter: 'drop-shadow(0 0 5px var(--neon-green))' }}
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav className="lg:hidden mt-4 pb-4 space-y-2">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsMenuOpen(false)}
                className={`block px-4 py-3 text-sm font-semibold transition-all rounded-full uppercase tracking-wider ${
                  isActive(link.path)
                    ? 'text-inverse bg-gradient-to-r from-primary to-blue border-2 border-primary'
                    : 'text-primary hover:text-blue bg-card border-2 border-green'
                }`}
              >
                {link.name}
              </Link>
            ))}
            <Button onClick={() => { onBookNow(); setIsMenuOpen(false); }} className="btn-primary w-full mt-4 font-bold">
              Book Now
            </Button>
          </nav>
        )}
      </div>
    </header>
  );
};